// PEOPLE PROFILE COMPONENTS DICTIONARY
// https://medium.com/@pratikpatel_60309/dynamic-importing-component-templates-with-vue-js-78d2167db1e7
export const peopleProfileComponents = [
    {
        text: "Notifications",
        icon: "notifications",
        name: "notifications",
        import: () => import("Modules/people/components/Notifications.vue"),
        permission: "",
    },
    {
        text: "Permissions",
        icon: "list",
        name: "permissions",
        import: () => import("Modules/people/components/Permissions.vue"),
        perms: ["permissions.read"],
    },
];
